<template>
  <div id="readed-boxes">
    <template v-if="boxes.length === 0">
      <div class="empty-state">
        <h5 class="text" v-html="$t('boxReader.readedBoxes.emptyState')"></h5>
      </div>
    </template>
    <transition name="fade">
      <template v-if="boxes.length > 0">
        <base-table
          class="table"
          :minWidth="'fit-content'"
          :body="boxes"
          :changeToCardAt="400"
          :columns="tableColumns"
        >
          <template slot="code" slot-scope="props">
            <div class="main-wrapper">
              <div class="code-wrapper">
                {{ props.item }}
              </div>
              <div
                class="action-wrapper delete"
                v-if="getWindowWidth < 400"
                @click.stop="removeBox(props.item)"
              >
                {{ $t("boxReader.readedBoxes.table.action.delete") }}
              </div>
            </div>
          </template>
          <template slot="delete-action" slot-scope="props">
            <div
              class="action-wrapper delete"
              @click.stop="removeBox(props.item)"
            >
              {{ $t("boxReader.readedBoxes.table.action.delete") }}
            </div>
          </template>
        </base-table>
      </template>
    </transition>
  </div>
</template>

<script>
import DeleteModal from "@/components/shared/Modals/DeleteModal";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ReadedBoxes",
  props: {
    boxes: {
      type: Array,
      required: true
    },
    withKeyBoard: {
      type: Array,
      required: true
    }
  },
  components: {},
  data: () => ({}),
  created() {},
  watch: {
    boxes() {
      this.saveQR(this.boxes);
    },
    withKeyBoard() {
      this.saveKeyBoard(this.withKeyBoard);
    }
  },
  computed: {
    ...mapGetters({
      getWindowWidth: "layout/getWindowWidth"
    }),
    tableColumns() {
      return [
        {
          key: "code",
          name: "boxReader.readedBoxes.table.headers.code"
        },
        {
          key: "delete-action",
          name: "",
          showOnMobile: false,
          needAction: false,
          sorting: false
        }
      ];
    }
  },
  methods: {
    ...mapActions({
      saveQR: "moving/saveQR",
      saveKeyBoard: "moving/saveKeyBoard",
      removeQR: "moving/removeQR"
    }),
    removeBox(item) {
      this.$eventBus.showModal({
        title: this.$t("boxReader.readedBoxes.deleteModal.title"),
        bind: {
          is: DeleteModal,
          width: "500px",
          text: this.$t("boxReader.readedBoxes.deleteModal.text", {
            qrNumber: item
          })
        },
        on: {
          deleteClicked: () => {
            this.$eventBus.closeModal();
            this.$emit("removeBox", item);
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#readed-boxes {
  .table {
    /deep/ .card-wrapper {
      padding-right: 0 !important;
      padding-left: 0 !important;
      #basic-card {
        padding-top: 5px !important;
        padding-bottom: 5px !important;
      }
    }
  }
}
.main-wrapper {
  display: flex;
  .code-wrapper {
    width: 100%;
    text-align: center;
  }
  .action-wrapper {
    margin-left: 20vw;
  }
}
</style>
